import React from 'react';
import { Autocomplete, Checkbox, Chip, TextField, Tooltip } from '@mui/material';

const SELECT_ALL = { id: 'select_all', name: 'Select All' };

const MultiSelectFilter = ({ label, options, value, onChange, disabled, loading, sx }) => {
    const selected = options.filter((option) => value.includes(option.id));
    const allSelected = options.length > 0 && selected.length === options.length;
    const handleChange = (_event, newValue, reason, details) => {
        if (details?.option?.id === SELECT_ALL.id) {
            onChange(reason === 'selectOption' ? options.map((option) => option.id) : []);
            return;
        }
        onChange(newValue.filter((option) => option.id !== SELECT_ALL.id).map((option) => option.id));
    };

    return (
        <Autocomplete
            multiple
            disableCloseOnSelect
            size="small"
            limitTags={1}
            options={options.length > 0 ? [SELECT_ALL, ...options] : options}
            value={allSelected ? [SELECT_ALL, ...selected] : selected}
            onChange={handleChange}
            isOptionEqualToValue={(option, selectedOption) => option.id === selectedOption.id}
            getOptionLabel={(option) => option.name ?? ''}
            disabled={disabled}
            loading={loading}
            renderOption={({ key, ...optionProps }, option, { selected: checked }) => (
                <li key={key ?? option.id} {...optionProps}>
                    <Checkbox size="small" sx={{ p: 0, pr: 1 }} checked={option.id === SELECT_ALL.id ? allSelected : checked} />
                    {option.name}
                </li>
            )}
            renderTags={(tagValues, getTagProps) => {
                const shown = tagValues.filter((option) => option.id !== SELECT_ALL.id);
                if (shown.length === 0) return null;
                const [first] = shown;
                return (
                    <>
                        <Chip label={first.name} size="small" {...getTagProps({ index: tagValues.indexOf(first) })} />
                        {shown.length > 1 && (
                            <Tooltip
                                title={
                                    <div style={{ whiteSpace: 'pre-line' }}>
                                        {shown
                                            .slice(1)
                                            .map((option) => option.name)
                                            .join('\n')}
                                    </div>
                                }
                            >
                                <Chip label={`+${shown.length - 1}`} size="small" />
                            </Tooltip>
                        )}
                    </>
                );
            }}
            renderInput={(params) => <TextField {...params} label={label} placeholder={selected.length ? undefined : 'All'} />}
            sx={sx}
        />
    );
};

export default MultiSelectFilter;
